import React from 'react';
import { LentTableDigitalArchivalAids } from './lent-table-digital-ap';
import { LentTableDigitalArchivalUnits } from './lent-table-digital-archival-units';

export const LentDigital = () => {
  return (
    <>
      <LentTableDigitalArchivalUnits />
      <LentTableDigitalArchivalAids />
    </>
  );
};
